export abstract class BaseVO<T> {
  private __nominal!: void;

  constructor(readonly value: T) {}

  toJSON(): T {
    return this.value;
  }
}
